<template>
  <div class="bg_white pb48">
    <Mv />
    <!-- <h1 class="content_title">加入・購入手続き完了</h1> -->
    <p class="complete_text ab pl16 pr16 mt16">加入手続きを完了しました。</p>

    <div class="contract pl16 pr16 mt16">
      <p class="page_title ab">NP FAN CLUB  契約プラン</p>
      <div class="wrap">
        <div class="priceList mt16">
          <p class="price_title complete_title ab">{{ fanClubSelectPlanName }}</p>
        </div>
      </div>
      <div class="complete mt16 ab">
        <p class="">ご購入ありがとうございます。</p>
        <p class="">ご注文は以下のとおり承りました。</p>
        <p class="mt5">ご不明な点がある場合は、会員IDと以下のオーダーIDとともにお問い合わせいただくよう、お願いいたします。</p>
        <div class="payment_wrap mt25">
          <label for="credit" class="payment_title ar">オーダーID</label>
          <p class="autoComplete__input">{{ fanClubOrderId }}</p>
        </div>
      </div>

    </div>


    <div class="product pl15 pr15 mt20">
      <p class="page_title ab">ご注文の製品</p>
      <div class="price mt16">
        <div class="pb24">
          <div class="priceList mt5">
            <p class="price_title ar">{{ fanClubSelectPlanName }}</p>
          </div>
          <div class="priceList mt5">
            <p class="price_title ar">税込</p>
            <p class="price_number rb"><span class="yen">￥</span>{{ fanClubsSelectPlanPrice.toLocaleString() }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="payment pl15 pr15 mt16">
      <p class="page_title ab">お支払方法</p>
      <div class="payment_wrap mt16">
        <label for="credit" class="payment_title ar">クレジットカード</label>
        <p class="autoComplete__input">{{ fanClubCreditCardNumber }}</p>
      </div>
    </div>
    <div class="btn_wrap">
      <!-- <router-link class="btn_blue confirm_btn" :to="{ name: 'fanClubRegister' }">視聴する</router-link> -->
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Mv from '@/components/fanClub/RegisterMv'

export default {
  components: {
    Mv
  },
  computed: mapGetters(['fanClubSelectPlanName', 'fanClubsSelectPlanPrice', 'fanClubCreditCardNumber', 'fanClubOrderId']),
}
</script>

<style lang="css" scoped>
.content_title {
  max-width: 170px;
}
.complete_text {
  color: #009FA9;
}
.complete {
  font-size: 14px;
}
.priceList {
  display: flex;
  justify-content: space-between;
}

.price_title {
  font-size: 14px;
}
.price_number {
  font-size: 16px
}
.price_number.large {
  font-size: 22px;
}
.yen {
  font-size: 12px;
}

.complete_title {
  font-size: 18px;
}

.tax {
  font-size: 14px;
}

.product, .payment {
  margin-top: 40px;
}

.alert {
  color: #FF0404;
  font-size: 14px;
}

.payment_title {
  font-size: 14px;
}
.btn_wrap {
  margin-top: 40px;
  padding-bottom: 40px;
}
</style>



// WEBPACK FOOTER //
// src/views/fanClub/register/Complete.vue